import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import { Container } from 'reactstrap';
import { defineMessages } from 'react-intl';

import Page from '../../components/layout/Page';
import GenericLayout from '../../components/layout/GenericLayout';
import SEOTitle from '../../components/head/SEOTitle';
import RobotsMeta from '../../components/head/RobotsMeta';
import ThankYouPageContent from '../../components/checkout/ThankYouPageContent';
import CommonPage from '../../types/CommonPage';

const messages = defineMessages({
  successfulPurchasePageTitle: {
    id: 'checkout.successfulPurchasePageTitle',
    defaultMessage: 'Your order has been registered!'
  }
});

@observer
export class KlarnaInstantShoppingThankYouPage extends Component {
  render() {
    return (
      <Page
        name={CommonPage.KLARNA_INSTANT_SHOPPING_THANK_YOU}
        className="KlarnaInstantShoppingThankYouPage"
      >
        <Container className="KlarnaInstantShoppingThankYouPage__container">
          <GenericLayout
            content={
              <Fragment>
                <SEOTitle title={messages.successfulPurchasePageTitle} />
                <RobotsMeta noindex />
                <ThankYouPageContent />
              </Fragment>
            }
          />
        </Container>
      </Page>
    );
  }
}

export default KlarnaInstantShoppingThankYouPage;



// WEBPACK FOOTER //
// ./src/pages/KlarnaInstantShoppingThankYouPage/index.jsx